import { User } from '@src/main/modules/user/domain/user.interface';

const SUPER_ADMIN_ROLE = 'SUPER_ADMIN';

export const isUserInSessionOrRoleSuperAdmin = (
  item: { employeeId?: string; role?: string },
  currentUser: User | null,
): boolean => {
  const isSuperAdminRole = item.role === SUPER_ADMIN_ROLE;
  const isSelf = currentUser && item.employeeId === currentUser.employeeId;

  return isSuperAdminRole || !!isSelf;
};
